import { render, staticRenderFns } from "./PlanetaryRevelationDescript.vue?vue&type=template&id=55664d00"
import script from "./PlanetaryRevelationDescript.vue?vue&type=script&setup=true&lang=js"
export * from "./PlanetaryRevelationDescript.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports